import { render, staticRenderFns } from "./SalesCart.vue?vue&type=template&id=5147a848&"
import script from "./SalesCart.vue?vue&type=script&lang=js&"
export * from "./SalesCart.vue?vue&type=script&lang=js&"
import style0 from "./SalesCart.vue?vue&type=style&index=0&id=5147a848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports